/**
 * 예약 상품 리스트 - PC
 */
$(function () {
    let isLoading = false;  //로딩 여부 (중복 요청 방지)

    /**
     * 금액 콤마 추가
     *
     * @param int amount
     * @reutrn string
     */
    function addComma(amount) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    /**
     * 금액 콤마 제거
     *
     * @param string str
     * @return number
     */
    function delComma(str) {
        return Number(str.replace(/,/g, ''));
    }

    function getNight(checkInDate, checkOutDate) {
        const inDate = new Date(checkInDate);
        const outDate = new Date(checkOutDate);

        // 날짜 차이 계산 (밀리초 -> 일수)
        const diffTime = outDate - inDate;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        return diffDays;
    }

    /**
     * 예약 상품 리스트 검색 Ajax 요청 처리
     */
    function loadData() {
        if (isLoading) return; // 중복 로딩 방지
        isLoading = true;

        $('#loading').show();

        $.ajax({
            url: '/ajax/bookList',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: $('#set_load_form').serialize(), // 폼 데이터 직렬화해서 보내기
            dataType: 'json',
            success: function(response) {
                $('#loading').hide();
                isLoading = false;

                if (response) {
                    renderItems(response);

                    //최대 할인율 업데이트
                    $('#max-discount').text(`${response.maxDiscount}% 할인`);
                }
            },
            error: function(xhr, status, error) {
                $('#loading').hide();
                isLoading = false;
                alert('데이터를 불러오는 중입니다.');
            }
        });
    }

    /**
     * 화면 HTML 출력
     */
    function renderItems(response) {
        const lists = response.list; //배열

        const base_ts = response.base_ts;  //타임스탬프
        const night = response.night; //몇박몇일
        const chkin = response.chkin;  //시작일
        const chkout = response.chkout;  //종료일

        let html = '';
        if (Array.isArray(lists) && lists.length > 0) {
            html = lists.map(function(item) {
                let itemSubClosed = (item.closed == 'Y') ? '<span class="end_str" style="font-weight:bold;color:#ff0000">'+item.title_closed+'</span>' : '';
                let disabled = (item.closed == 'Y') ? 'disabled' : '';
                let closed = (item.closed == 'Y') ? 'closed' : '';
                let clickClassName = (item.closed == 'Y') ? 'book-product-closed-click' : 'book-product-click';  // 리스트 항목 클릭 이벤트 바인딩 Class

                let normal_html = '';
                normal_html = `<del>${addComma(item.normal)}원</del>`;

                let npayPriceHtml = '';
                if (item.npay_price != '') {
                    npayPriceHtml = `<p class="npay"><img src="https://img.ocean2you.co.kr/renew/reservation/icon_npay.png" alt="npay">${addComma(item.npay_price)}원~</p>`;
                }

                return `
                    <li class="${closed} ${clickClassName}" data-price="${item.price}" data-normal="${item.normal}" data-room-name="${item.room_name}" data-min-person="${item.min}" data-max-person="${item.max}" data-person="${item.min}" data-basets="${base_ts}" data-night="${night}" data-chkin="${chkin}" data-chkout="${chkout}" data-sang="${item.sang}">
                        <label class="title" >
                            <div>
                                <input type="radio" name="room" ${disabled}>
                                ${item.title} <span class="txtRed">${item.title_sub}</span>
                                ${itemSubClosed}
                            </div>
                            <div>${item.person_range}</div>
                            <div class="pri">${normal_html} <span class="txtRed">${addComma(item.price)}원~</span>${npayPriceHtml}</div>
                        </label>
                    </li>
                `;
            }).join('');
        } else {
            let activeItemValue = document.querySelector('.tab-list-type.active').innerText ?? '할인이벤트';
            html = `<p style="text-align:center;font-size:25px;font-weight:600;padding:60px 0;">${activeItemValue} 객실이 없습니다.</p>`;
        }

        $('#book-product-list').html(html);
    }

    /**
     * 맨 처음 자동 로딩
     */
    $(document).ready(function() {
        loadData();
    });

    /**
     * 달력 chkin, chkout "선택완료" 후, 예약리스트 화면 갱신
     */
    $('#btn-booking-choice-date').on('click', function() {
        var dateArr = confirmDate();
        var chkin = dateArr[0];
        var chkout = dateArr[1];

        if (chkin != '') {  //체크인 날짜 있으면
            $('#choice_sdate').val(chkin);
            $('#sub_sdate').val(chkin);

            const night = getNight(chkin, chkout);

            $('#prev_night').val(night);

            const roomDailyDateText = `[${chkin}(${getKoreanWeekday(chkin)})]`;
            $('#room-daily-date-text').text(roomDailyDateText);

        } else {
            alert('체크인 날짜를 선택해 주세요.');
            return;
        }

        if (chkout != '') {  //체크아웃 날짜 있으면
            $('#choice_edate').val(chkout);
            $('#sub_edate').val(chkout);
        } else { //체크아웃 날짜 미선택 시, 체크인 날짜와 같게 처리
            $('#choice_edate').val(getNextDate(chkin));
            $('#sub_edate').val(getNextDate(chkin));
            $('#prev_night').val('1');
        }

        loadData();
    });

    /**
     * 달력에서 체크인, 체크아웃 날짜 확인
     *
     * 달력의 chkin, chkou을 확인해서 리턴
     */
    function confirmDate() {
        const $calendar = $('#cal_pc .calendar');
        const $chkin = $calendar.find('.day.chkin');
        const $chkout = $calendar.find('.day.chkout');

        // DOM에서 찾지 못하면 저장된 data attribute 값 사용 (모바일에서 월 이동한 경우)
        const startDate = $chkin.attr('data-dt') || $('#cal_pc').attr('data-selected-chkin') || '';
        const endDate = $chkout.attr('data-dt') || $('#cal_pc').attr('data-selected-chkout') || '';

        return [startDate, endDate];
    }

    // 다음날짜 반환
    function getNextDate(dateStr) {
        const date = new Date(dateStr);
        date.setDate(date.getDate() + 1);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 0-based
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    //특정 날짜의 한글 요일 반환
    function getKoreanWeekday(dateStr) {
        const days = ['일', '월', '화', '수', '목', '금', '토'];
        const date = new Date(dateStr);
        const dayIndex = date.getDay(); // 0(일) ~ 6(토)
        return days[dayIndex];
    }

    /**
     * 탭 클릭 이벤트 처리
     */
    $('.tab-list-type').on('click', function() {
        let listType = $(this).data('type');
        const url = new URL(window.location);

        if (window.location.pathname === '/booking') {
            url.searchParams.set('list_type', listType);
            window.history.pushState({}, '', url);
        }

        $('#list_type').val(listType);

        loadData();
    });

});
